<template>
 <div class="layui-layout layui-layout-admin">
 			111111111111111111111
 		</div>
</template>

<script>
import { listApi } from '../../api/index.js'
export default {
  data() {
    return {

        type:['首页','猪','牛','羊','鸡','驴'],
        params:{
          livestockType:2,
          page:1,
          pageSize:10
        }

    }
  },
  // 注册组件
  components: {

  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      // this.user = JSON.parse(localStorage.getItem('userInfo'))
      // this.getTotal()
      this.list()
  },
  methods: {
      list(){
        listApi(this.params)
          .then(res => {

          })
          .catch(err => {
            _this.loading = false
            _this.$message.error('加载失败，请稍后再试！')
          })
      },

  }
}
</script>

<style scoped>
 .viewer-footer{
 				display: none;
 			}
 			.historyFlv{
 				display: none;
 			}
 			.layui-btn-primary:hover{
 				border-color:#30BF30!important;
 				color: #30BF30;
 			}
 			.bigimg{width:600px;position: fixed;left: 0;top: 0; right: 0;bottom: 0;margin:auto;display: none;z-index:999999999;border: 10px solid #fff;}
 			.mask{position: fixed;left: 0;top: 0; right: 0;bottom: 0;background-color: rgba(0,0,0,0.5);z-index: 888888888;transition:all 1s;display: none}
 			.mask>img{position: fixed;right:10px;top: 10px;width: 40px;}
 			.mask>img:hover{cursor:pointer}
 			#point{
 				width: 800px;
 				height: 450px;
 				position: absolute;
 				top: 80px;
 				left: 20px;
 			}
 			.orderTab{
 				height: 70%;
 				overflow: auto;
 			}
 			.layui-body{
 				width: 100%;
 				left:0!important;
 			}

</style>



// WEBPACK FOOTER //
// src/views/index/index.vue